import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';

export interface MyNonprofitMenuItemProps {
    charityId: number | string;
    onClickExtra?: () => void;
}

export const MyNonprofitMenuItem = (props: MyNonprofitMenuItemProps) => (
    <LeftMenuItem
        icon="pe-7s-network"
        label="My Nonprofit"
        to={`/charities/${props.charityId}/edit`}
        trackingAction="My Charity"
        gtmCategory="My Charity"
        forceReload
        onClickExtra={props.onClickExtra}
    />
);
